import { SalesTeamsManagementTable } from '../components';

const SalesTeamsManagement = () => {
  return <SalesTeamsManagementTable/>;
};

export default SalesTeamsManagement;
